/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the NavigationComponent interface.
 */
export function instanceOfNavigationComponent(value) {
    return true;
}
export function NavigationComponentFromJSON(json) {
    return NavigationComponentFromJSONTyped(json, false);
}
export function NavigationComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'back': json['back'] == null ? undefined : json['back'],
        'forward': json['forward'] == null ? undefined : json['forward'],
        'submit': json['submit'] == null ? undefined : json['submit'],
    };
}
export function NavigationComponentToJSON(json) {
    return NavigationComponentToJSONTyped(json, false);
}
export function NavigationComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'back': value['back'],
        'forward': value['forward'],
        'submit': value['submit'],
    };
}
